export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6340.92b43082.jpg";